///<reference path="../../../typings/tsd.d.ts" />

module agencyRegistration {
    
    let settings = {
        tplPath : './app/modules/agency-registration/',
        routeParams : {
            'create': ['cnpj'].join("&")
        }
    };
    
    angular.module('tools', []);
    angular.module('agencyRegistrationApp', ['ui.router', 'validations', 'ui.mask', 'ngMessages', 'address', 'tools', 'banks', 'branches', 'commonData', 'ngMaterial']).config(routerConfig);

    function routerConfig($locationProvider: ng.ILocationProvider,
        $stateProvider: angular.ui.IStateProvider,
        $urlRouterProvider: angular.ui.IUrlRouterProvider) 
    {

        /*@ngInject*/
        $urlRouterProvider.otherwise('/search');

        $stateProvider
            .state('search',{
                url: "/search",
                views: {
                    "main@": {
                        templateUrl: settings.tplPath + "search/search-agent.html",
                        controller: "SearchController as $search"
                    }
                }
            })
            .state('search.create',{
                url: "/create?" + settings.routeParams.create,
                views: {
                    "create@search": {
                        templateUrl: settings.tplPath + "create/create-agent.html",
                        controller: "CreateController as $create"
                    },
                    "associate@search": {
                        templateUrl: settings.tplPath + "create/associate.html",
                        controller: "AssociateController as $associate"
                    }
                }
            })
            .state('success', {
                url: "/success",
                views: {
                    'success@': {
                        templateUrl: settings.tplPath + 'create/success-create.html',
                        controller: class {
                            agencyName: string;
                            constructor($state: angular.ui.IStateService){
                                if ($state.params["agency"])
                                    this.agencyName = $state.params["agency"].companyData.companyName;
                                else
                                    $state.go('search');
                            };
                        },
                        controllerAs: '$success'
                    }
                },
                params: {
                    agency: undefined
                },
            });
    }
    
    class MainController extends common.CommonDashboardController {};
    angular.module('agencyRegistrationApp').controller('MainController', MainController);
}
